module.exports = Promise.all([parcelRequire.load("l6xiM"), parcelRequire.load("8k0g9"), parcelRequire.load("1nkUG")]).then(() => parcelRequire('iDn1L'));